import React from "react";
import { PageHeader } from "@/pages/About";

const H = ({ children }) => <h2 className="font-heading text-lg font-semibold text-navy-900">{children}</h2>;

const TermsOfUse = () => (
  <div>
    <PageHeader eyebrow="Legal" title="Terms of Use" subtitle="The terms governing your use of the WECH-RB certification platform." />
    <section className="wechr-section">
      <div className="wechr-container max-w-3xl space-y-5 text-sm leading-relaxed text-navy-800">
        <p>By accessing or using the WECH-RB platform, you agree to these Terms of Use.</p>
        <H>Certification Nature</H>
        <p>WECH-RB DD Certification is a document-review-based certification. It is not an on-site audit and does not guarantee legal or regulatory compliance. Certification reflects an assessment of the evidence submitted at the time of review.</p>
        <H>Accurate Information</H>
        <p>You are responsible for the accuracy, authenticity, and completeness of all information and documents you submit. Submitting false or misleading evidence may result in denial, suspension, or revocation of certification.</p>
        <H>AI-Assisted Review</H>
        <p>The platform uses AI to generate a preliminary gap analysis. AI output is advisory only; final certification decisions are made by WECH-RB reviewers.</p>
        <H>Certification Decisions</H>
        <p>WECH-RB reserves the right to approve, reject, request additional information, require enhanced review, or suspend or revoke certification at its discretion.</p>
        <H>Intellectual Property</H>
        <p>The WECH-RB name, Code of Conduct, scorecards, and certificate designs are the property of WECH-RB and may not be reproduced without permission.</p>
        <H>Limitation of Liability</H>
        <p>WECH-RB is not liable for decisions made by third parties in reliance on a certificate, or for any indirect or consequential damages.</p>
        <p className="text-[var(--wechr-muted-text)]">This document is provided for platform demonstration purposes and does not constitute legal advice.</p>
      </div>
    </section>
  </div>
);

export default TermsOfUse;
